import { StationIcon } from '@carvia/ros-client-types';
import * as yup from 'yup';
import { findTimeRangesError } from '@/utils/validate-time-ranges';
import { COUNTRY_CODES } from '@/utils/countries';
import { localizedField } from './validation-types/localized-field';

const timeRanges = yup
  .array(
    yup.object({
      start: yup.number().required(),
      end: yup.number().required(),
    }),
  )
  .required()
  .test(
    'valid-ranges',
    'Opening hours must not overlap and close after opening',
    (ranges) => !findTimeRangesError(ranges),
  );

export const stationSchema = yup.object({
  info: localizedField.required(),
  notice: localizedField.required(),
  slug: yup.string().required(),
  location: yup.object().required(),
  street: yup.string().required(),
  zip: yup.string().required(),
  city: yup.string().required(),
  state: yup.string().nullable(),
  countryCode: yup
    .string()
    .oneOf([...COUNTRY_CODES])
    .required(),
  icon: yup.string().oneOf(Object.values(StationIcon)).nullable().notRequired(),
  invoiceSuffix: yup.string().required(),
  googleMapsReviewCtaUrl: yup
    .string()
    .transform((value) => (value === '' ? null : value))
    .url()
    .nullable()
    .optional(),
  isGoogleMapsReviewEnabled: yup
    .boolean()
    .transform((_value, originalValue) => originalValue === true || originalValue === 'true')
    .required(),
  openingHours: yup
    .array(
      yup.object({
        weekday: yup.number().required(),
        ranges: timeRanges,
      }),
    )
    .min(7)
    .required(),
  isHidden: yup.boolean().required(),
  isInternal: yup.boolean().required(),
  ignoredHolidays: yup
    .array(
      yup.object({
        holidayType: yup.string().oneOf(['specificDate', 'publicHoliday']).required(),
        holiday: yup
          .object()
          .when('holidayType', {
            is: (holidayType: string) => holidayType === 'specificDate',
            then: (schema) =>
              schema.shape({
                specificDate: yup.string().required(),
              }),
            otherwise: (schema) =>
              schema.shape({
                rule: yup.string().required(),
                year: yup.string().optional(),
              }),
          })
          .required(),
        isClosed: yup.boolean().optional(),
        alternativeOpeningHours: yup
          .lazy((val, { parent }) => {
            if (val == null || parent?.isClosed) return yup.mixed().notRequired();
            return yup.object({
              ranges: timeRanges.min(1),
            });
          })
          .optional(),
      }),
    )
    .required(),
  counters: yup
    .array(
      yup.object({
        id: yup.string().optional(),
        name: yup.string().trim().required(),
      }),
    )
    .optional(),
});
